<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <!-- <ny-banner v-if="banner.length" :banner="banner[0]" /> -->
    <div class="banner">
      <img :src="curBanner" width="100%" />
    </div>

    <div class="crumbs">
      <div>排球俱乐部 <span v-if="club">&nbsp;> {{ club.clubName }}</span></div>
    </div>
    <div :class="['club-container', type]">
      <div class="container-width">
        <div class="detail">
          <div class="content" v-if="club">
            <div class="club-icon">
              <img :src="club.clubLogo" :alt="club.clubName" v-if="club.clubLogo" />
              {{ club.clubName }}
            </div>
            <div class="intro">
              <div v-html="clubIntroduction"></div>
              <p><br></p>
            </div>
            <el-row :gutter="24" class="club-detail">
              <el-col :span="20">
                <h3 class="title"><span>选手名单</span></h3>
                <div v-if="club.clubTeamList" style="padding-top: 12px;">
                  <el-row :gutter="12">
                    <el-col :span="8" v-for="item in club.clubTeamList" :key="item.id">
                      <div class="dl">
                        <el-image lazy :src="item.userImg" style="width: 115px; height: 115px;" :alt="item.userName" height="115" />
                        <div class="t1">
                          <h3>{{ item.userName }}</h3>
                          <p>
                            {{ item.birthDate ? formatDate(Date.parse(item.birthDate), 'YYYY.mm.dd') : '' }}
                          </p>
                          <p>
                            {{ item.height }}cm &nbsp;
                            {{ item.weight }}kg
                          </p>
                        </div>
                        <div class="t2">
                          <p>{{ item.number }}</p>
                          <p>{{ item.position }}</p>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="4">
                <h3 class="title"><span>教练组</span></h3>
                <div class="coach" v-if="club.clubCoachList">
                  <el-row :gutter="16">
                    <el-col :span="12" v-for="item in club.clubCoachList" :key="item.id">
                      <dl>
                        <dt>
                          <el-image class="img" lazy :src="item.coachImg" :alt="item.coachName" />
                        </dt>
                        <dd>
                          <p>{{ item.coachName }}</p>
                          <p>{{ item.title }}</p>
                        </dd>
                      </dl>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import { getBanner } from '@/service/apis/common'
import { getClubList } from '@/service/apis/club'


export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'Club',
  data () {
    return {
      banner: [],
      banners: [
        require('../../../../assets/images/banner1.png'),
        require('../../../../assets/images/banner2.png'),
        require('../../../../assets/images/banner3.png')
      ],
      clubs: [],
      type: 'club33',
      id: '',
    }
  },
  computed: {
    curBanner () {
      switch (this.id) {
        case '33': // 男子
        case '36':
          this.type = 'club33'
          return this.banners[0]
        case '27': // 女子
        case '37':
          this.type = 'club27'
          return this.banners[1]
        default :
          this.type = 'club35' // 沙滩
          return this.banners[2]
      }
    },
    club () {
      if (this.id && this.clubs.length) {
        return this.clubs.find(item => item.id === parseInt(this.id))
      }
      return null
    },
    clubIntroduction () {
      if (this.club && this.club.introduction) {
        let text = this.club.introduction

        return text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp; ');
      }
      return ''
    }
  },
  watch: {
    '$route.query.type'(val) {
      this.id = val
    }
  },
  created() {
    getBanner(this).then(data => {
      // banner 9
      if (data[9]) {
        this.banner = [...data[9]]
      }
    })
    let id = this.$route.query.type
    if (id) {
      this.id = id
      this.getClub()
    } else {
      this.$router.back()
    }
  },
  methods: {
    getClub () {
      getClubList.call(this).then(res => {
        if (res.errCode == 0) {
          let { clubList } = res.data
          if (clubList.length) {
            clubList.forEach(club => {
              this.clubs.push(club)
            })
          }
        }
      })
    }
  },
}
</script>
<style scoped>
.detail {
  padding-top: 12px;
  height: auto;
  overflow: hidden;
}

.detail .content {
  padding: 12px 0;
  padding-bottom: 48px;
  color: #666;
  min-height: 250px;
  line-height: 28px;
}
.club-icon {
  padding: 0 16px;
  font-size: 36px;
  line-height: 150px;
}
.club-icon img {
  border-radius: 75px;
  width: 150px;
  height: 150px;
  font-size: 12px;
  object-fit: cover;
  float: left;
  margin-right: 22px;
}
.intro {
  line-height: 28px;
  font-size: 16px;
  color: #666;
  padding: 16px 16px 36px 16px;
  border-bottom: solid 28px #f6f6f6;
}
.club-detail {
  height: auto;
  overflow: hidden;
  padding: 16px;
  padding-bottom: 36px;
}
.club-detail h3.title {
  height: auto;
  overflow: hidden;
  font-size: 20px;
  color: #010101;
  line-height: 42px;
}
.club-detail h3.title span {
  display: block;
  float: left;
  position: relative;
}
.club-detail h3.title span::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #4c2ac9;
}
.club-detail .dl {
  margin: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 16px;
  box-sizing: border-box;
  background: url(../../../../assets/images/club-bg.png) right bottom no-repeat;
}

.club-detail .dl img {
  font-size: 12px;
  background-color: #fff;
}
.club-detail .t1,
.club-detail .t2 {
  text-align: center;
}
.club-detail .t1 {
  font-size: 12px;
  padding-top: 24px;
  line-height: 22px;
}
.club-detail .t1 h3 {
  color: #2e0776;
  padding-bottom: 6px;
  font-size: 14px;
  font-weight: bold;
}
.club-detail .t2 {
  color: #505050;
  font-size: 12px;
  height: auto;
  text-align: center;
  padding: 0 12px;
  line-height: 36px;
  padding-top: 28px;
  width: 75px;
  box-sizing: border-box;
  color: #fff;
}

.club-detail .t2 p:first-child {
  padding: 8px 0;
  font-size: 36px;
  border-bottom: solid 1px #fff;
}
.coach {
  padding: 16px 16px 12px 0;
}
.coach dl {
  padding: 8px 0;
}
.coach dl dt {
  width: 100%;
  padding-bottom: 100%;
  position: relative;
}
.coach dl dt .img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.coach dl dd {
  font-size: 12px;
  padding: 6px 0px;
  text-align: center;
  background-color: #f7f7f7;
  border-right: solid 6px #4c2ac9;
  color: #999;
}
.coach dl dd p:first-child {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}

.banner {
  height: auto;
  overflow: hidden;
  width: 100%;
}
.banner img {
  vertical-align: middle;
}
.club-container {
  height: auto;
  overflow: hidden;
  position: relative;
}
.club-container::after,
.club-container::before {
  width: calc((100% - 1280px) / 2);
  position: absolute;
  top: 0;
  content: '';
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.club-container::after {
  right: 0;
  background-position: left top;
}
.club-container::before {
  left: 0;
  background-position: top right;
}

.club-container.club33::before {
  background-image: url(../../../../assets/images/bg1-1.png);
}
.club-container.club33::after {
  background-image: url(../../../../assets/images/bg1-2.png);
}

.club-container.club27::before {
  background-image: url(../../../../assets/images/bg2-1.png);
}
.club-container.club27::after {
  background-image: url(../../../../assets/images/bg2-2.png);
}

.club-container.club35::before {
  background-image: url(../../../../assets/images/bg3-1.png);
}
.club-container.club35::after {
  background-image: url(../../../../assets/images/bg3-2.png);
}
</style>
